import { render } from "./PaymentPage.vue?vue&type=template&id=6ac705b6&scoped=true"
const script = {}

import "./PaymentPage.vue?vue&type=style&index=0&id=6ac705b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac705b6"]])

export default __exports__